export default "__VITE_ASSET__BSeBiVS$__"